import { z } from 'zod';
import { ExperimentType } from 'modules/graphql';
import { EXPERIMENT_NAME_CHAR_LIMIT } from 'modules/experiments/constants';

// Can be used in name field for monitor page
const EXPERIMENT_NAME_RULE = z
  .string()
  .min(1, 'Name is required')
  .max(
    EXPERIMENT_NAME_CHAR_LIMIT,
    `Must be ${EXPERIMENT_NAME_CHAR_LIMIT} or fewer characters long`,
  );
const EXPERIMENT_TYPE_RULE = z.nativeEnum(ExperimentType);

export const CREATE_EXPERIMENT_SCHEMA = z.object({
  name: EXPERIMENT_NAME_RULE,
  type: EXPERIMENT_TYPE_RULE,
});
